import { globalSpinnerReducerKey } from './GlobalSpinnerConstants';

export function globalSpinner(state) {
  return state.get(globalSpinnerReducerKey) || new Map();
}

export function isShown(state) {
  return globalSpinner(state).get('isShown');
}

export function spinnerType(state) {
  return globalSpinner(state).get('type');
}
